import { INK } from '../Landing/ui';

// Journal-styled auth method row — same API as Login/LoginServiceButton
// (logo, link, name, isLogin, onClick) so LoginServices can swap between
// them behind its `journal` prop. `primary` is the filled teal lead button.
export default function AuthMethodButton({
  logo,
  link,
  name,
  isLogin,
  onClick,
  primary,
}) {
  const className = `tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-gap-3 tw-rounded-full tw-px-5 tw-py-3 tw-text-[15px] tw-font-semibold tw-no-underline tw-transition-all tw-duration-200 ${
    primary
      ? 'tw-border-0 tw-bg-primary-600 tw-text-white hover:tw-bg-primary-700 hover:tw-text-white tw-shadow-[0_10px_30px_-10px_rgba(0,137,123,0.7)]'
      : `tw-border tw-border-solid tw-border-[#C9C0AA] dark:tw-border-[#3A4D44] tw-bg-white dark:tw-bg-[#15231E] ${INK} hover:tw-border-primary-600 hover:tw-text-primary-700 dark:hover:tw-text-primary-300`
  }`;
  const content = (
    <>
      <span className="tw-flex tw-w-7 tw-shrink-0 tw-items-center tw-justify-center">
        {logo}
      </span>
      <span className="tw-flex-1 tw-text-center">
        {isLogin ? 'Log in' : 'Sign up'} with {name}
      </span>
    </>
  );
  if (onClick)
    return (
      <button type="button" onClick={onClick} className={className}>
        {content}
      </button>
    );
  return (
    <a href={link} className={className}>
      {content}
    </a>
  );
}
